import { Component, Input, OnInit } from "@angular/core";
import { TranslationService } from "../../../_services/translation.service";
import { UserManagementService } from "../../../_services/user-management.service";
import { FormGroup, FormGroupDirective } from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { UserPrivilegeType } from "../user-management-models/user-privilege-type.enum";
import { sleep } from "../../../_helpers/sleep";
import { UserFormErrorsEnum } from "../user-management-models/user-form-errors.enum";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";

@Component({
  selector: "user-management-form-system-privileges",
  templateUrl: "./user-management-form-system-privileges.component.html",
  styleUrls: ["./user-management-form-system-privileges.component.scss"],
})
export class UserManagementFormSystemPrivilegesComponent implements OnInit {
  @Input("userId")
  public userId: "new" | string = "new";
  public translations$: Observable<ITranslations>;
  public isSuperUser: boolean = false;
  public systemPrivilegesForm: FormGroup;
  public UserPrivilegeType = UserPrivilegeType;
  public hideSuperAdminOptions = false;
  public areLimitedPrivilegesShown = false;
  public refundPasswordVisibility = false;
  public arePrivilegesValid = true;

  constructor(
    private translationService: TranslationService,
    private usesManagementService: UserManagementService,
    private userSystemPrivileges: FormGroupDirective,
    private sessionManagerService: SessionManagerService
  ) {
    this.translations$ = this.translationService.translations;
    this.isSuperUser =
      sessionManagerService.getCurrentUserPermissions().isSuperAdmin;
  }

  public ngOnInit() {
    this.systemPrivilegesForm = this.userSystemPrivileges.form;
  }

  public changePrivilegeHandler(value: string) {
    this.areLimitedPrivilegesShown = value === UserPrivilegeType.Limited;

    this.formChangeHandler().then();
  }
  public async formChangeHandler(_event?: Event) {
    await sleep(10); // to let the event finish and update the form value
    const formValue = this.systemPrivilegesForm.value;

    this.arePrivilegesValid = !(
      formValue.privilegeType === UserPrivilegeType.Limited &&
      !formValue.viewOnly &&
      !formValue.cashCollection &&
      !formValue.creditCollection
    );
    this.systemPrivilegesForm.controls["privilegeType"].setErrors(
      this.arePrivilegesValid
        ? null
        : {
            [UserFormErrorsEnum.BadSystemStatus]:
              UserFormErrorsEnum.BadSystemStatus,
          }
    );
  }

  public toggleVisibility($event: MouseEvent) {
    $event.preventDefault();
    this.refundPasswordVisibility = !this.refundPasswordVisibility;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-form-system-privileges/user-management-form-system-privileges.component.ts